"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "comabbio": {
    "fa876193": [{
      "hkey": "bc687cd4",
      "slug": "comabbio",
      "name": "Comabbio",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-della-palude": [{
      "hkey": "bc687cd4",
      "slug": "comabbio",
      "name": "Comabbio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "40acf2d2": [{
      "hkey": "bc687cd4",
      "slug": "comabbio",
      "name": "Comabbio",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-zerbino": [{
      "hkey": "bc687cd4",
      "slug": "comabbio",
      "name": "Comabbio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6563dbcc": [{
      "hkey": "bc687cd4",
      "slug": "comabbio",
      "name": "Comabbio",
      "primary": true,
      "skipSearch": false
    }],
    "careggio": [{
      "hkey": "bc687cd4",
      "slug": "comabbio",
      "name": "Comabbio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ddf49c33": [{
      "hkey": "bc687cd4",
      "slug": "comabbio",
      "name": "Comabbio",
      "primary": true,
      "skipSearch": false
    }],
    "monte-pelada": [{
      "hkey": "bc687cd4",
      "slug": "comabbio",
      "name": "Comabbio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;